import { z } from 'zod';

export const PhoneLegitimation = z.array(z.object({ legitimation: z.boolean(), timestamp: z.number() }));

export type Schema_PhoneLegitimation = z.infer<typeof PhoneLegitimation>;
